export default __webpack_public_path__ + "static/media/greatballlegends.941f56af.png";